// Selectors for the buttons and scrollable container
const readMoreButton = document.querySelector('.dynamic-collection-banner__read-more');
const plusButton = document.querySelector('.dynamic-collection-banner__plus-button');
const scrollableContainer = document.querySelector('.collection-banner--description.dynamic');

// List of classes to toggle 'active'
const activeClasses = [
  '.dynamic-collection-banner__link-list',
  '.collection-banner--description.dynamic',
  '.dynamic-collection-banner__collection-information',
  '.dynamic-collection-banner',
  '.dynamic-collection-banner__read-more-wrapper',
  '.dynamic-collection-banner__read-more',
  '.dynamic-collection-banner__read-more-icon',
  '.dynamic-collection-banner__plus-button',
  '.collection-banner--title.dynamic'
];

// Add or remove the active class
function toggleActiveState(button) {
  const isActive = scrollableContainer.classList.contains('active'); // Check current active state
  const readMoreWrapper = document.querySelector('.dynamic-collection-banner__read-more-wrapper.active');

  if (isActive && button.classList.contains('active')) {
    // Scroll to the top before closing the description
    scrollableContainer.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    });

    // Reset the fade background when closing
    if (readMoreWrapper) {
      readMoreWrapper.style.background = ''; // Reset to CSS-defined fade
    }
  }

  // Toggle active class for all selectors
  activeClasses.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.classList.toggle('active');
    }
  });
  
}

// Handle the fade effect for the read-more-wrapper
function handleScrollFade() {
  // Select active elements
  const readMoreWrapper = document.querySelector('.dynamic-collection-banner__read-more-wrapper.active');
  const activeScrollableContainer = document.querySelector('.collection-banner--description.dynamic.active');

  // Ensure elements exist
  if (!readMoreWrapper || !activeScrollableContainer) {
    return;
  }

  // Check if the user has scrolled to the bottom of the container
  const isScrolledToBottom =
    activeScrollableContainer.scrollTop + activeScrollableContainer.clientHeight >= activeScrollableContainer.scrollHeight;

  // Remove or reset the background
  if (isScrolledToBottom) {
    readMoreWrapper.style.background = 'none'; // Remove fade
  } else {
    readMoreWrapper.style.background = ''; // Reset to CSS-defined fade
  }
}

// Event listener for the "Read More" button
if (readMoreButton) {
  readMoreButton.addEventListener('click', () => {
    toggleActiveState(readMoreButton);
  });
}

// Event listener for the "Plus" button (Mobile)
if (plusButton) {
  plusButton.addEventListener('click', () => {
    toggleActiveState(plusButton);
  });
}